import React from 'react';

import { makeStyles, Switch as MuiSwitch } from '@material-ui/core';

type SwitchProps = {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
    hide?: boolean;
    classes?: { root?: React.CSSProperties };
};
export const Switch = ({ checked, onChange, disabled, hide, classes }: SwitchProps) => {
    const defaultClasses = createStyle(createSwitchClasses({ classes }));
    return hide ? null : (
        <MuiSwitch
            checked={checked}
            classes={{
                track: defaultClasses.switch_track,
                switchBase: defaultClasses.switch_base,
                thumb: defaultClasses.switch_thumb,
                root: defaultClasses.switch_root,
            }}
            onClick={disabled || !onChange ? undefined : () => onChange?.(!checked)}
        />
    );
};

const createStyle = (styles: {}): Record<string, string> => makeStyles((theme) => styles)();

const createSwitchClasses = ({
    classes,
}: Pick<SwitchProps, 'classes'>): Record<string, React.CSSProperties | Record<string, React.CSSProperties>> => {
    return {
        switch_root: { padding: 0, width: 51, height: 31, ...classes?.root },
        switch_track: { opacity: 1, backgroundColor: '#C7C7CC', borderRadius: 16 },
        switch_thumb: { width: 27, height: 27 },
        switch_base: {
            padding: 2,
            color: '#FFFFFF',
            '&.Mui-checked': { color: '#FFFFFF' },
            '&.Mui-checked + .MuiSwitch-track': { opacity: 1, backgroundColor: '#E5A033' },
        },
    };
};
